<template>
  <div class="config-section">
    <div class="form-container">
      <!-- Firmantes Section -->
      <div class="form-section">
        <div class="section-header">
          <h3 class="section-title">Firmantes por Defecto</h3>
          <vs-button color="primary" type="filled" @click="openSignersModal">
            Modificar Firmantes
          </vs-button>
        </div>
        <p class="section-description">
          Configura los firmantes que se agregarán automáticamente a tus documentos.
        </p>
      </div>

      <!-- Espectadores Section -->
      <div class="form-section">
        <div class="section-header">
          <h3 class="section-title">Espectadores por Defecto</h3>
          <vs-button color="primary" type="filled" @click="openViewersModal">
            Modificar Espectadores
          </vs-button>
        </div>
        <p class="section-description">
          Configura los espectadores que tendrán acceso por defecto a tus documentos.
        </p>
      </div>

      <div class="form-section">
        <div class="section-header">
          <h3 class="section-title">Configuraciones de documento</h3>
        </div>
        <p class="section-description"><strong>Tipos de firma admitidas:</strong><br>
          <span>Configura la compatibilidad de tipos de firma para este documento. <a style="cursor: pointer" @click="signatureTypes = true">Configurar.</a></span>
        </p>

        <p class="section-description"><strong>Tipo de representación de firmado</strong> <br>
          <span>Selecciona una de las dos tipos de representaciones que ponemos a tu disposición (PAdES por defecto). <a
            style="cursor: pointer" @click="signedMethodPopupEnable = true">Seleccionar</a></span> <br>
          <span>Tipo de firmado: <strong>{{ signMode == null ? 'No configurado' : SIGN_STRATEGIES[signMode] }}</strong></span> <br>
          <span v-if="signMode === 'PDF_SIGNATURE'">Posición seleccionada: <strong>{{ SIGN_POSITION[signPosition] }}</strong></span>
        </p>
      </div>
    </div>

    <vs-button color="success" type="filled" @click="saveDefaults" class="mt-4 mr-2">
      Guardar Configuración
    </vs-button>

    <vs-button color="danger" type="border" @click="deleteConfig" class="mt-4">
      Borrar configuración
    </vs-button>
    <!-- Modal for Default Signers -->
    <vs-popup
      title="Editar Firmantes por Defecto"
      :active.sync="isSignersModalOpen"
      :fullscreen="false"
      :width="600"
      @open="ensureAtLeastOneSigner"
    >
      <div class="vx-col w-full mb-4 mt-3">
        <div class="flex items-center justify-end">
          <span class="mr-3">Activar firma ordenada</span>
          <vs-switch v-model="sortableSignatures" />
        </div>
        <p class="mt-2 text-sm text-muted text-right" v-if="sortableSignatures">
          Arrastra las tarjetas para establecer el orden de firma.
        </p>
      </div>
      <div class="list">
        <draggable v-model="defaultSigners" :disabled="!sortableSignatures" handle=".drag-handle" ghost-class="dragging">
          <transition-group>
            <SignerCard
              v-for="(signer, index) in defaultSigners"
              :key="signer.id"
              :signer="signer"
              :index="index"
              @remove-signer="confirmRemoveSigner(index)"
              @popUpLimitFunction="popUpLimitFunction"
              :sortable="sortableSignatures"
              :ref="'signerCard' + index"
            />
          </transition-group>
        </draggable>
      </div>
      <vs-button color="primary" type="filled" @click="addSigner" class="mt-4">
        Añadir Firmante
      </vs-button>

      <vs-popup title="Activa Plan Profesional" :active.sync="upgradePro">
        <p>Esta función está disponible solo para el Plan Profesional, obtén todos los beneficios del Plan además con un 20% de descuento en todos los documentos extra que compres.</p>

        <planPro :upgradeProPopup="setUpgradePro"/>

      </vs-popup>
    </vs-popup>

    <!-- Modal for Default Viewers -->
    <vs-popup
      title="Editar Espectadores por Defecto"
      :active.sync="isViewersModalOpen"
      :fullscreen="false"
      :width="600"
    >
      <div class="list">
        <div v-for="(viewer, index) in defaultViewers" :key="index" class="list-item-full">
          <div class="item-index-badge">{{ index + 1 }}</div>
          <div class="item-details-full">
            <vs-input
              v-model="viewer.email"
              label-placeholder="Correo Electrónico del Espectador"
              dense
              class="input-item-full"
            />
            <vs-input
              v-model="viewer.name"
              label-placeholder="Nombre del Espectador"
              dense
              class="input-item-full"
            />
          </div>
          <vs-button
            icon-pack="feather"
            icon="icon-trash"
            color="danger"
            type="border"
            @click="confirmRemoveViewer(index)"
            class="remove-btn-full"
          >
          </vs-button>
        </div>
      </div>
      <vs-button color="primary" type="filled" @click="addViewer" class="mt-4">
        Añadir Espectador
      </vs-button>
    </vs-popup>


    <vs-popup title="Configura los tipos de firmado compatibles" :active.sync="signatureTypes">
      <vs-card>
        <div class="pt-3 px-3">
          <h3 class="mb-3">Tipos de firmado</h3>
          <p class="">Configura los métodos de firma admitidos para este documento.</p>
          <vs-row>
            <vs-col class="my-3" vs-type="grid" vs-justify="center" vs-align="center" vs-w="6">
              <img src="@/assets/images/document/identidad.svg" width="90" class="d-block m-auto" alt="">
              <vs-checkbox class="mt-6 d-inline-b" v-model="signatureType" name="signatureType" data-vv-as="VERIFICAMEX" vs-value="VERIFICAMEX">Identidad</vs-checkbox>
            </vs-col>

            <vs-col class="my-3" vs-type="grid" vs-justify="center" vs-align="center" vs-w="6">
              <img src="@/assets/images/document/sat.svg" width="90" class="d-block m-auto" alt="">
              <vs-checkbox class="mt-6 d-inline-b" v-model="signatureType" name="signatureType" data-vv-as="EFIRMA" vs-value="EFIRMA">SAT</vs-checkbox>
            </vs-col>

            <vs-col class="mt-3 d-block m-auto" vs-type="grid" vs-justify="center" vs-align="center" vs-w="6">
              <img src="@/assets/images/document/firel.svg" width="90" class="d-block m-auto" alt="">
              <vs-checkbox class="mt-6 d-inline-b" v-model="signatureType" name="signatureType" data-vv-as="FIREL" vs-value="FIREL">FIREL</vs-checkbox>
            </vs-col>
          </vs-row>
        </div>
        <div slot="footer">
          <vs-row vs-justify="flex-end">
            <vs-button type="filled" color="primary" @click="signatureTypes = false">Aceptar</vs-button>
          </vs-row>
        </div>
      </vs-card>
    </vs-popup>

    <vs-popup class="signed_method"  title="Selecciona un Método de Firmado" :active.sync="signedMethodPopupEnable">
      <sign-selector :open-sign-position-popup="openSignPositionPopup" :submit-new-document="signSelectorAction"></sign-selector>
      <vs-popup title="Selecciona la posición de la firma" :active.sync="signPositionPopupEnable">
        <sign-position-selector :set-sign-position="setSignPosition" :submit-new-document="signSelectorAction"></sign-position-selector>
      </vs-popup>
    </vs-popup>

  </div>
</template>

<script>
import SignerCard from "../../documents/documents-create/SignerCard.vue";
import draggable from 'vuedraggable';
import planPro from "@/views/pages/buy/plans/PlanPro.vue";
import SignPositionSelector from "../../documents/components/SignPositionSelector.vue";
import SignSelector from "../../documents/components/SignSelector.vue";
import {SIGN_POSITION, SIGN_STRATEGIES} from "../../../../config/app";

export default {
  components: {SignSelector, SignPositionSelector, draggable, SignerCard, planPro },
  data() {
    return {
      defaultSigners: [],
      defaultViewers: [],
      isSignersModalOpen: false,
      isViewersModalOpen: false,
      sortableSignatures: false,
      upgradePro: false,
      signatureTypes: false,
      signatureType: [],
      signedMethodPopupEnable: false,
      signMode: null,
      signPosition: 'NONE',
      signPositionPopupEnable: false,
    };
  },
  computed: {
    SIGN_POSITION() {
      return SIGN_POSITION
    },
    SIGN_STRATEGIES() {
      return SIGN_STRATEGIES
    },
  },
  methods: {
    openSignPositionPopup() {
      this.signPositionPopupEnable = true;
    },
    signSelectorAction(selector) {
      this.signMode = selector;
      this.signPositionPopupEnable = false;
      this.signedMethodPopupEnable = false;
    },
    setSignPosition(position) {
      this.signPosition = position;
    },
    popUpLimitFunction() {
      this.upgradePro = true;
    },
    setUpgradePro(state) {
      this.upgradePro = state;
    },
    openSignersModal() {
      this.isSignersModalOpen = true;
      this.ensureAtLeastOneSigner()
    },
    openViewersModal() {
      this.isViewersModalOpen = true;
      this.ensureAtLeastOneViewer()
    },
    ensureAtLeastOneSigner() {
      if (this.defaultSigners.length === 0) {
        this.addSigner();
      }
    },
    ensureAtLeastOneViewer() {
      if (this.defaultViewers.length === 0) {
        this.addViewer();
      }
    },
    addSigner() {
      this.defaultSigners.push({
        id: (Math.random() + 1).toString(36).substring(7),
        name: '',
        email: '',
        phone: '',
        restrictSign: false,
        restrictSelector: 'RFC',
        rfc: '',
      });
    },
    confirmRemoveSigner(index) {
      if (confirm('¿Estás seguro de que deseas eliminar este firmante?')) {
        this.removeSigner(index);
      }
    },
    removeSigner(index) {
      this.defaultSigners.splice(index, 1);
    },
    addViewer() {
      this.defaultViewers.push({ name: '', email: '' });
    },
    confirmRemoveViewer(index) {
      if (confirm('¿Estás seguro de que deseas eliminar este espectador?')) {
        this.removeViewer(index);
      }
    },
    removeViewer(index) {
      this.defaultViewers.splice(index, 1);
    },
    deleteConfig() {
      this.$store.dispatch('account/storeDefaultSettings', {
        data: {
          defaultSignatures: [],
          defaultSpectators: [],
          sortableSignatures: false,
        }
      }).then(
        result => {
          console.log(result)
          this.defaultSigners = []
          this.defaultViewers = []
          this.sortableSignatures = false
          this.$store.dispatch("alert/success", "La configuración se ha guardado correctamente.");
        }
      )
    },
    saveDefaults() {
      const signers = this.defaultSigners.map(signer => {
        return {
          rfc: signer.rfc,
          name: signer.name,
          email: signer.email,
          phone: signer.phone
        }
      })
      const spectators = this.defaultViewers.map(viewer => {
        return {
          name: viewer.name,
          email: viewer.email,
        }
      })
      this.$store.dispatch('account/storeDefaultSettings', {
        data: {
          defaultSignatures: signers,
          defaultSpectators: spectators,
          sortableSignatures: this.sortableSignatures,
          allowTypeSignatures: this.signatureType,
          documentSignPosition: this.signPosition,
          documentMode: this.signMode
        }
      }).then(
        result => {
          console.log(result)
          this.$store.dispatch("alert/success", "La configuración se ha guardado correctamente.");
        }
      )
    }
  },
  async created() {
    this.$store.dispatch('account/getDefaultSettings').then(
      result => {
        let signers = result.data.find(
          item => item.attributes.settingKey === "default_signatures"
        );
        let viewers = result.data.find(
          item => item.attributes.settingKey === "default_spectators"
        )
        let sortableSignatures = result.data.find(
          item => item.attributes.settingKey === "sortable_signatures"
        )
        let allowSignatureTypes = result.data.find(
          item => item.attributes.settingKey === 'allow_type_signatures'
        )
        let documentMode = result.data.find(
          item => item.attributes.settingKey === 'document_mode'
        )
        let documentSignPosition = result.data.find(
          item => item.attributes.settingKey === "document_sign_position"
        )
        if (signers !== undefined) {
          let signersParsed = JSON.parse(signers.attributes.settingValue)
          signersParsed = signersParsed.map(signer => {
            signer.id = (Math.random() + 1).toString(36).substring(7);
            if (signer.rfc) {
              signer.restrictSign = true;
              if (signer.rfc.length >= 14) {
                signer.restrictSelector = 'CURP';
              } else {
                signer.restrictSelector = 'RFC';
              }
              signer.rfc = signer.rfc.toUpperCase();
            } else {
              signer.restrictSign = false;
              signer.restrictSelector = 'RFC';
              signer.rfc = '';
            }
            return signer;
          })
          this.defaultSigners = signersParsed;
        }
        if (viewers !== undefined) {
          this.defaultViewers = JSON.parse(viewers.attributes.settingValue);
        }
        if (sortableSignatures !== undefined) {
          this.sortableSignatures = JSON.parse(sortableSignatures.attributes.settingValue);
        }
        if (allowSignatureTypes !== undefined) {
          this.signatureType = JSON.parse(allowSignatureTypes.attributes.settingValue);
        }
        if (documentMode !== undefined) {
          this.signMode = JSON.parse(documentMode.attributes.settingValue);
        }
        if (documentSignPosition !== undefined) {
          this.signPosition = JSON.parse(documentSignPosition.attributes.settingValue);
        }
      }
    )
  }
};
</script>

<style scoped>
.config-section {
  padding: 20px;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-section {
  background: #ffffff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-title {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.section-description {
  font-size: 14px;
  color: #555;
  margin: 0;
}

.list-item-full {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
  margin-bottom: 12px;
}

.item-index-badge {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background-color: #6c63ff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.item-details-full {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-item-full {
  width: 100%;
}

.remove-btn-full {
  align-self: flex-start;
}
</style>
